export default "__VITE_ASSET__BzC_Xdeu__"